var BlimpExtMap = new Class({
	Extends: BlimpExt,

	post_process: function(){
		var title = this._link.getAttribute('data-title');
		if(this._element.getElement('.map_title'))
		this._element.getElement('.map_title').set('html', title);

		if (!this.map) {
			this.create_map();
		}

		//this.addEvent('hide', this.self_destruct.bind(this));

		this.parent();
	},

	create_map: function(){
		var self = this;
		var rpc	= this._link.getAttribute('data-rpc-map');
		var _map_container = this._element.getElement('.map_container');

		_map_container.empty()

		var _map = new Element('div', {
			'class': 'map'
		}).inject(_map_container);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function(){
				var data = this.get_data();
				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	},

	self_destruct: function() {
		Core.destruct(this.remote, this);
		Core.destruct(this.map, this);
	}
});
